import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  type ApplicationConfig,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideAppFooter } from '@sbe-spinoff-client/app-footer';
import { provideAppShell, withNoMatchRedirect } from '@sbe-spinoff-client/app-shell';
import {
  provideStaffHttpApiBaseUrl,
  staffApiBaseUrlInterceptor,
  staffCredentialsInterceptor,
} from '@sbe-spinoff-client/staff-http';
import {
  provideStaffOidcAuth,
  staffBearerInterceptor,
  staffPermissionDeniedInterceptor,
} from '@sbe-spinoff-client/staff-oidc-auth';
import { appRoutes } from './app.routes';
import { smsStaffAuthz } from './core/staff-authz';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideStaffHttpApiBaseUrl(() => environment.smsApiBaseUrl),
    // '/senders'는 admin→originator 리네임 이전의 옛 경로명 — 더 이상 존재하지 않는
    // 라우트라 return 경로 폴백으로 쓰면 안 된다(2026-08-11 셸 루트 배치 중 발견).
    provideStaffOidcAuth({ returnPathFallback: '/originators', authz: smsStaffAuthz }),
    provideHttpClient(withXhr(), 
      withInterceptors([
        staffApiBaseUrlInterceptor,
        staffCredentialsInterceptor,
        staffBearerInterceptor,
        staffPermissionDeniedInterceptor,
      ]),
    ),
    provideRouter(appRoutes, withNoMatchRedirect()),
    provideAppFooter(),
    provideAppShell({ showThemeToggle: true }),
  ],
};
